export const environment = {
  general: {
    production: false,
    product: 'retail',
    title: 'Kiosco El Molino',
    url: 'https://backend.buhomanager.com:444/',
    useMultiClient: false,
    nameMultiClient: 'elmolino',
    logoUrl: 'https://buho-images.s3.sa-east-1.amazonaws.com/elmolino/logo.svg',
    carouselImages: 0,
    columnsItemMobile: 2,
    validateStock: false,
    mobileApp: true,
    paymentServiceUrl: 'https://backend.buhomanager.com:450',
  },
  bucketConfig: {
    region: 'sa-east-1',
    accessKey: '',
    secretAccessKey: '',
    bucketName: 'buho-images',
    bucketFolderToSavePhotos: 'multiclient/upload/photos-articles/',
    bucketFolderToSaveFiles: 'multiclient/upload/files/',
  },
  htmlContent: {
    separator: '',
  },
  mercadoPago: {
    useMercadoPago: true,
  },
  security: {
    encryptionKey: 'ed27da393433b5b6a3174d38d74cbcca4b98d0992773cb8a04d37cd40bea498a=',
  },
  localPayment: false,
  shipping: {
    useShipping: true,
    correoArgentino: false,
    defaultPackage: {
      weight: 500,
      height: 25,
      width: 25,
      length: 25,
    },
  },
};
